/** Used to simulate an awaitable delay. Shouldn't be used on non-development envs */
export const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
